import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column container py-10" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12 d-flex justify-content-end gap-2" }
const _hoisted_9 = ["onClick", "data-kt-indicator"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Save", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Saving... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_AddressForm = _resolveComponent("AddressForm")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      "initial-values": _ctx.initValues,
      "validation-schema": _ctx.formSchema,
      class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
      ref: "profileForm"
    }, {
      default: _withCtx(({ handleSubmit, values, validate }) => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(($event: any) => (handleSubmit(values, _ctx.submitForm)), ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_FormField, {
                required: true,
                containerClass: "col-lg-6 col-md-6 col-12",
                label: "First Name",
                name: "first_name",
                placeholder: "First Name",
                type: "text"
              }),
              _createVNode(_component_FormField, {
                required: true,
                containerClass: "col-lg-6 col-md-6 col-12",
                label: "Last Name",
                name: "last_name",
                placeholder: "Email",
                type: "text"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FormField, {
                required: true,
                containerClass: "col-lg-4 col-md-4 col-12",
                label: "Email",
                name: "email",
                placeholder: "Email",
                type: "text"
              }),
              _createVNode(_component_FormField, {
                containerClass: "col-lg-4 col-md-4 col-12",
                label: "Mobile Number",
                name: "mobile_number",
                placeholder: "Mobile Number",
                mask: _ctx.maskingMobile,
                type: "text"
              }, null, 8, ["mask"]),
              _createVNode(_component_FormField, {
                required: true,
                value: values.date_of_birth,
                containerClass: "col-lg-4 col-md-4 col-12",
                label: "Date of Birth",
                name: "date_of_birth",
                placeholder: "Date of Birth",
                type: "datepicker",
                dateFormat: "DD/MM/YYYY",
                datevalueFormat: "YYYY-MM-DD",
                disabledDate: _ctx.disabledDates
              }, null, 8, ["value", "disabledDate"])
            ])
          ]),
          _createVNode(_component_AddressForm, {
            values: values,
            country: values.country,
            state: values.state,
            onCountryChange: _ctx.handleCountryChange,
            onCountryBlur: _ctx.handleCountryBlur,
            onStateChange: _ctx.handleStateChange,
            onStateBlur: _ctx.handleStateBlur
          }, null, 8, ["values", "country", "state", "onCountryChange", "onCountryBlur", "onStateChange", "onStateBlur"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "btn align-self-center btn-new-design-secondary w-lg-auto w-md-auto w-100",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
              }, " Cancel "),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-new-design-primary align-self-center w-lg-auto w-md-auto w-100",
                onClick: validate,
                "data-kt-indicator": _ctx.loading ? 'on' : null
              }, _hoisted_12, 8, _hoisted_9)
            ])
          ])
        ], 40, _hoisted_2)
      ]),
      _: 1
    }, 8, ["initial-values", "validation-schema"])
  ]))
}